import type { CurrentStoreProps } from '../SideBar';

export type StatusApp = 'trial' | 'expired' | 'ativo';

export function getStatusApp(infos: CurrentStoreProps): StatusApp {
	const { app_vencimento, dias_restantes_trial, vencimento_trial } = infos;
	const agora = Date.now();

	if (dias_restantes_trial > 0 && agora < vencimento_trial * 1000) return 'trial';
	if (agora >= app_vencimento * 1000) return 'expired';

	return 'ativo';
}
